import LoginPage from "../pages/LoginPage";
import ResetPasswordForm from "../pages/doctors/ResetPasswordPage";
import ForgotPasswordPage from "../pages/doctors/ForgotPasswordPage";
import RequireAuth from "../components/RequireAuth";
import DoctorDashboard from "../pages/dashboards/DoctorDashboard";
import ConstanteForm from "../components/doctor/ConstanteForm";
import ConstanteUpdate from "../components/doctor/ConstanteUpdate";
import ConstanteDetail from "../components/constante/ConstanteDetail"; // Remplacement de ConstanteView par ConstanteDetail
import RecordForm from "../components/doctor/RecordForm";
import RecordRegistration from "../components/doctor/RecordRegistration";
import RecordUpdate from "../components/doctor/RecordUpdate";
import RecordView from "../components/doctor/RecordView";
import ConsultationWizardWrapper from "../components/consultation/ConsultationWizardWrapper";
import PreEmploymentSelection from "../components/consultation/CertificatMedicalPreEmbauche";
import DashboardHomeDoctor from "../pages/doctors/DashboardHomeDoctor";

export const docteurRoutes = (onLoginSuccess: (token: string) => void) => [
  {
    path: "/doctor/login",
    element: <LoginPage onLoginSuccess={onLoginSuccess} />,
  },
  { path: "/doctor/resetpassword", element: <ResetPasswordForm /> },
  { path: "/doctor/forgot-password", element: <ForgotPasswordPage /> },
  {
    path: "/doctor/dashboard",
    element: (
      <RequireAuth>
        <DoctorDashboard />
      </RequireAuth>
    ),
    children: [
      { path: "constante", element: <ConstanteForm /> },
      { path: "constante/edit/:id", element: <ConstanteUpdate /> },
      { path: "constante/view/:id", element: <ConstanteDetail /> }, // Remplacement de ConstanteView par ConstanteDetail
      { path: "record/new", element: <RecordRegistration /> },
      { path: "record", element: <RecordForm /> },
      { path: "record/view/:id", element: <RecordView /> },
      { path: "record/edit/:id", element: <RecordUpdate /> },
      { path: "", element: <DashboardHomeDoctor /> }, // Simplification de la route par défaut
      {
        path: "consultation/new/:patientId",
        element: <ConsultationWizardWrapper />,
      },
      {
        path: "certificat-pre-embauche",
        element: <PreEmploymentSelection />,
      },
      {
        path: "certificat-pre-embauche/:patientId",
        element: <PreEmploymentSelection />,
      },
    ],
  },
];

